/* eslint-disable import/no-cycle */
import { TodosConfig } from '../../../modules/administration/accountParameter/components/todoListPanel/todoListTypes';
import { BackgroundChecks } from './candidate';

export type FitBand = {
  poorFit?: number;
  mediumFit: number;
  goodFit: number;
};

export type Accounts = {
  analyticsEnabled?: boolean;
  id?: string;
  automated?: boolean;
  calendarEnabled?: boolean;
  monetizationEnabled?: boolean;
  smb?: boolean;
  configuration?: {
    dashboardEnabled?: boolean;
    groupEventEnabled?: boolean;
    webApplyEnabled?: boolean;
    certnEnabled?: boolean;
    freeFormQuestionEnabled?: boolean;
    unresponsiveAgedPeriod?: number;
    seasonalContractPeriod?: number;
    unresponsiveDismissPeriod?: number;
    hireFormEnabled?: boolean;
    requisitionEnabled?: boolean;
    modernHireEnable?: boolean;
    scheduleMatchEnabled?: boolean;
    virtualRecruiterEnabled?: boolean;
    languageEvaluationEnabled?: boolean;
    shouldEnableAppliedPositions?: boolean;
    hireFormEnabledPositions?: string[];
    modernHireTemplateIdList?: string[];
    dialogFlowEnabled?: boolean;
    candidateReofferEnabled?: boolean;
    isShiftIntersectable?: boolean;
    requisitionActiveThresholdDays?: number;
    hireWebhookForCustomer?: {
      url: string;
    };
    candidateNotificationBeforeInWeeks?: number;
    managementOverview?: ManagementOverviewType;
    managementOverviewEnabled?: boolean;
    adhocInterviewEnabled?: boolean;
    resumeEnabled?: boolean;
    hireFormTemplateEnabled?: boolean;
    languageEvaluationTemplateEnabled?: boolean;
    hireFormJsonApiViewerEnabled?: boolean;
    fitbandTemplateEnabled?: boolean;
    i9CheckEnabled?: boolean;
    workbright?: {
      enabled: boolean;
      subDomain?: string;
    };
    supportedLanguages?: {
      label: string;
      value: string;
    }[];
    needReviewEnabled?: boolean;
    offerConditionsEnabled?: boolean;
    automaticHireDisabled?: boolean;
    hrReviewUiEnabled?: boolean;
    filterCandidateByDays?: number;
    adminPositionWatchAndFollowEnabled?: boolean;
    isMonitorRecruitersFilterDistrictEnabled?: boolean;
    freeOnHoldInterviews?: boolean;
    interviewRequestExpiryDays?: number;
    appointmentHoldThresholdInDays?: number;
    maxLimitInterviews?: number;
    languageEvaluationValidityInDays?: number;
    maxImageLimit?: number;
    automaticLanguageEvaluationEnabled?: boolean;
    candidateReapplicationPeriodInDays?: number;
    seekerInFlightDurationInHours?: number;
    seekerMaxHoursMatchingEnabled?: boolean;
    requisitionWebHookRetryCount?: number;
    effectiveDateInDays?: number;
    offerAcceptancePeriod?: number;
    positionMiningEnabled?: boolean;
    positionMiningRadius?: number;
    modernHirePassThreshold?: number;
    modernHireSubDomain?: string;
    fitBand?: FitBand;
    accountParameterEnabled?: boolean;
    automateHiringAfterOffer?: boolean;
    isBulkAssignModeEnabled?: boolean;
    isQuestionnaireTemplateEnabled?: boolean;
    questionTemplateEnabled?: boolean;
    showVideoQuestions?: boolean;
    showDocumentQuestions?: boolean;
    enablePositionSalaryCeilingValidation?: boolean;
    todos?: TodosConfig;
  };
  requisitionWebHookurl?: string;
  owners?: string[];
  superOwners?: string[];
  screeningOptions?: BackgroundChecks;
  subscription?: {
    automation: boolean;
  };
  type?: AccountType;
  name?: string;
  dialogFlowAgents?: DialogFlowAgent[];
  analyticsPages?: ThirdPartIntegrationUrl[];
  prototypeFeaturesPages?: ThirdPartIntegrationUrl[];
  accountHash?: string;
  prototypeEnabled?: boolean;
  remainingCredits?: number;
  authorization?: boolean;
  settings?: {
    receiveSeekerHireInfoAt: string;
  };
  bulkAssignOperation?: BulkAssignOperation | null;
};

export type BulkAssignOperation = {
  isBulkAssignInProgress?: number | null;
  bulkAssignStartedAt?: Date;
  totalBulkAssignChunkCount?: number;
  processedBulkAssignedChunkCount?: number;
  processedBy?: string;
};

export type ThirdPartIntegrationUrl = {
  engURL: string;
  frURL: string;
  engName: string;
  frName: string;
  minimumRole?: string;
};

export type DialogFlowAgent = {
  defaultLanguageCode: string;
  agentId: string;
  location: string;
  displayName?: string;
  timeZone?: string;
};

export enum AccountType {
  PERSONAL = 'personal',
  BUSINESS = 'business',
}

type SubArcLimits = {
  safe: number;
  normal: number;
  danger: number;
};

type ManagementOverviewType = {
  outstandingOffers: {
    minValue: number;
    maxValue: number;
    subArcLimits: SubArcLimits;
  };
  hiresProcessing: {
    minValue: number;
    maxValue: number;
    subArcLimits: SubArcLimits;
  };
  backgroundChecksDelayed: {
    minValue: number;
    maxValue: number;
    subArcLimits: SubArcLimits;
  };
  overdueApprovals: {
    minValue: number;
    maxValue: number;
    subArcLimits: SubArcLimits;
  };
  stalledCandidates: {
    minValue: number;
    maxValue: number;
    subArcLimits: SubArcLimits;
  };
  openRequisitions: {
    minValue: number;
    maxValue: number;
    subArcLimits: SubArcLimits;
  };
};

export interface BulkAssignOperations {
  id: string;
  isBulkAssignInProgress: number;
  bulkAssignStartedAt: firebase.firestore.Timestamp;
  bulkAssignCompletedAt: firebase.firestore.Timestamp;
  processedBulkAssignedChunkCount: number;
  totalBulkAssignChunkCount: number;
}
